<template>
  <FrontendProductCarouselPlacementOrchestrator
    location="homepage"
    placement="homepage-1"
    :ssr-limit="1"
    @add-to-cart="handleAddToCart"
    @toggle-favorite="handleToggleFavorite"
  />
</template>

<script setup>
await useSiteMeta()
const siteSettings = useSiteSettingsStore()
const { title: siteTitle, description: siteDescription } = storeToRefs(siteSettings)

const handleAddToCart = (productData) => {
  console.log('Sepete eklendi:', productData)
}

const handleToggleFavorite = (product) => {
  console.log('Favorilere eklendi:', product)
}

useHead({
  title: `Ana Sayfaa - ${siteTitle.value}`,
  meta: [
    {
      name: 'description',
      content: siteDescription.value || "Binlerce satıcı ve milyonlarca ürün Binaffan'da! En uygun fiyatlar ve güvenli alışveriş deneyimi için hemen keşfetmeye başlayın."
    }
  ]
})
</script>
